import React, { useState, useEffect, Fragment } from "react";
import Autocomplete, {usePlacesWidget} from "react-google-autocomplete";
import Select from 'react-select'

const amenityOptions = [{"name":"Full Service","slug":"full-service"},{"name":"Jacuzzi/Hot Tub","slug":"jacuzzi-hot-tub"},{"name":"Fishbowl","slug":"fishbowl"},{"name":"Nuru","slug":"nuru"},{"name":"Outcall","slug":"outcall"},{"name":"Private Parties","slug":"private-parties"},{"name":"Food","slug":"food"},{"name":"Alcohol","slug":"alcohol"},{"name":"Karaoke","slug":"karaoke"},{"name":"Parking","slug":"parking"},{"name":"Accept Credit Cards","slug":"accept-credit-cards"}]
const categoryOptions = [{"name":"Massage","slug":"massage"},{"name":"Soapy","slug":"soapy"},{"name":"Gentlemen’s Clubs","slug":"gentlemens-clubs"},{"name":"Go-Go","slug":"go-go"},{"name":"Freelancers","slug":"freelancers"},{"name":"Red Light Districts","slug":"red-light"}];
const defaultParams = {
  q: '',
  name: '',
  lat: '',
  lng: '',
  category: '',
  region: '',
  amenities: [],
}
const SearchBox = (props) => {
  const { filters, isLoading, onSearch } = props;
  const [formData, setFormData] = useState({
    ...defaultParams,
  });
  const handleChange = (e) => {
    console.log(e.target.value);
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }
  const handleClickAmenity = (e) => {
    const newAmenities = formData.amenities ? formData.amenities : [];
    if(newAmenities.find((am) =>(am === e.target.value))) {
      const newData = {
        ...formData,
        amenities: newAmenities.filter((am) =>(am !== e.target.value))
      }
      setFormData(newData)
    } else {
      const newData = {
        ...formData,
        amenities: [...newAmenities, e.target.value]
      }
      setFormData(newData)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(formData);
  }

  const handleReset = (e) => {
    e.preventDefault();
    setFormData({...defaultParams});
    onSearch({...defaultParams});
  }
  const handleGetCurrent = (e) => {
    e.preventDefault();
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition( (position) => {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ location: {lat: position.coords.latitude, lng: position.coords.longitude} })
        .then((response) => {
          setFormData({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            q: response.results[0].formatted_address
          })
        })
      })
    }
  }
  const { ref } = usePlacesWidget({
    apiKey: '',
    options: {
      componentRestrictions: { country: "th" },
      fields: ["address_components", "geometry", "icon", "name"],
      strictBounds: false,
    },
    onPlaceSelected: (place) => {
      setFormData({
        ...formData,
        q: place.name,
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      })
    }
  })
  const regionGroups = (window.searchData?.regions || []).reduce((result, region) => {
    const country_name = region.country_name || 'Unknown';
    
    // Create a new group for the country_name if it doesn't exist
    if (!result[country_name]) {
      result[country_name] = [];
    }
  
    // Add the region to the country_name's group
    result[country_name].push(region);
  
    return result;
  }, {});
  
  const regionSelectOptions = Object.keys(regionGroups).sort().map((country_name) => {
    const country_code = regionGroups[country_name][0].country_code
    const groupOpts = [{
      label: <span>
        <img src={`/flags/${country_code.toLocaleLowerCase()}.svg`} width={20} height={15} alt={country_name} style={{marginRight: 5}}/>
        {country_name}
      </span>,
      value: `country:${country_code}`
    }]
    return [
      ...groupOpts,
      ...regionGroups[country_name].map((region) => ({
        value: region.slug,
        label: <span style={{paddingLeft: 25}}>{region.name}</span>,
      })),
    ]   
  }).flat();
  console.log('regionSelectOptions', regionSelectOptions)
  const categoryGroups = window.searchData?.categories || categoryOptions;

  useEffect(() => {
    setFormData({...formData, ...filters})
  }, [filters])

  return (
    <div className="search">
      <div className="row">
        <div className="col-md-12">
          <form action="/listing" acceptCharset="UTF-8" method="get" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-4">
                <Select
                  isClearable 
                  options={regionSelectOptions}
                  isDisabled={isLoading}
                  name="region"
                  placeholder="Select location"
                  classNamePrefix={`custom-select`}
                  onChange={e => setFormData({...formData, region: e?.value || ''})}
                />              
              </div>
              <div className="col-md-4">
                <div className="input-with-icon">
                  <i className="sl sl-icon-magnifier"></i>
                  <input
                    type="text"
                    name="name"
                    placeholder="Search listing by name"
                    value={`${formData.name || ''}`}
                    onChange={handleChange}
                    disabled={isLoading}
                  />
                </div>
              </div>
              <div className="col-md-4">
                  <select name="category"
                    value={formData.category}
                    onChange={handleChange}
                    disabled={isLoading}

                  >
                    <option>Select category</option>
                    {categoryGroups.map((option) => (
                      <option key={`opt-${option.slug}`} value={`${option.slug}`}>{option.name}</option>
                    ))}
                  </select>
                  
              </div>
              <div className="col-md-12">
                {/* <div className="row">
                  <div className="col-md-12">
                    <div className="checkboxes in-row amenities_checkbox">
                      <ul>
                        {
                          amenityOptions.map((amenity) => (
                            <li key={amenity.slug}>
                              <input id={amenity.slug} 
                                  type="checkbox" 
                                  name="amenities[]" 
                                  value={`${amenity.name}`}
                                  checked={formData.amenities && formData.amenities.find((am) => (am===amenity.name)) ? true : false}
                                  onChange={handleClickAmenity}
                                  disabled={isLoading}
                                />
                            <label htmlFor={amenity.slug}>{amenity.name}</label>
                          </li>
                          ))
                        }
       
                      </ul>
                    </div>
                  </div>
                </div> */}
                <div className="row">
                  <div className="col-md-12">
                    <button className="button"
                      type="submit"
                      disabled={isLoading}
                    >
                      <i className="fa fa-search"></i>
                      Search
                    </button>
                    <a href="#" onClick={handleReset}>Clear </a>
                  </div>
                </div>
              </div>
            </div>
          </form>{" "}
        </div>
      </div>
    </div>
  );
};

export default SearchBox;
